import { makeRequestAction } from './actions';
import { CANCEL } from '../constants/Actions';

export default conversationId => (dispatch, _, { apiV2 }) => {
  dispatch(makeRequestAction.start({ type: CANCEL }));

  return apiV2
    .cancelConversation(conversationId)
    .then(({ data }) =>
      apiV2
        .getConversationMessages(conversationId)
        .then(messages => [data, messages]),
    )
    .then(([data, { data: { messages } }]) =>
      dispatch(makeRequestAction.done({ ...data, messages })),
    )
    .catch(error => dispatch(makeRequestAction.error(error)));
};
